
<template>
    <vs-table>
    <template #thead>
      <vs-tr>
        <vs-th>
          Usuario
        </vs-th>
        <vs-th>
          Académico
        </vs-th>
        <vs-th>
          Movimiento
        </vs-th>
        <vs-th>
          Modificaciones
        </vs-th>
      </vs-tr>
    </template>
    <template #tbody>
      <vs-tr
        :key="i"
        v-for="(tr, i) in historial"
        :data="tr"
      >
        <vs-td>
            <p><strong>{{ tr.usuario }}</strong></p>
        </vs-td>
        <vs-td>
          <div v-if="tr.institucion">
            <p class="mb-0 text-uppercase"><small>Institución</small></p>
            <p><strong>{{tr.institucion}}</strong></p>
          </div>
          <div v-if="tr.ciclo_escolar">
            <p class="mb-0 text-uppercase"><small>Ciclo escolar</small></p>
            <p><strong>{{tr.ciclo_escolar}}</strong></p>
          </div>
        </vs-td>
        <vs-td>
          <div v-if="tr.accion">
            <p class="mb-0 text-uppercase"><small>Acción</small></p>
            <p><strong>{{tr.accion}}</strong></p>
          </div>
          <div v-if="tr.codigo_detalle">
            <p class="mb-0 text-uppercase"><small>Código de detalle</small></p>
            <p><strong>{{tr.codigo_detalle}}</strong></p>
          </div>
          <div v-if="tr.fecha">
            <p class="mb-0 text-uppercase"><small>Fecha</small></p>
            <p><strong>{{tr.fecha}}</strong></p>
          </div>
          <div v-if="tr.descripcion">
            <p class="mb-0 text-uppercase"><small>Descripción</small></p>
            <p><strong>{{tr.descripcion}}</strong></p>
          </div>
        </vs-td>
        <vs-td>
            <div class="d-flex">
                <div v-if="tr.monto">
                    <p class="mb-0 text-uppercase"><small>Monto</small></p>
                    <md-chip class="mini-chip col-red" ><strong>{{tr.monto}}</strong></md-chip>
                </div>
            </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
<script>
    export default {
      props: [
        'historial'
      ],
      data:() => ({
      })
    }
    </script>

<style scoped>

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }
</style>
        